module.exports = __webpack_public_path__ + "static/media/private-account.be5d3e2a.svg";